import { Injectable, Inject, Optional } from '@angular/core';
import { REQUEST } from '@app/shared/token/tokens';
import { PlatformService } from '@core/services/util/platform.service';
import { get } from 'lodash-es';

export enum DEVICE {
    MOBILE = 'mobile',
    DESKTOP = 'desktop'
}

@Injectable({
    providedIn: 'root'
})

export class DeviceService {

    constructor(
        @Optional() @Inject(REQUEST) private request,
        private platform: PlatformService
    ) { }

    isMobile() {
        let isMobile = false;
        let userAgent = '';
    
        if (this.platform.isServer()) {
            if (this.request.is_custom_req) {
                return get(this.request, 'is_device_mobile', false);
            }
    
            // Get user-agent from request headers
            userAgent = get(this.request, 'headers.user-agent', '');
    
            if (userAgent.toLowerCase() === 'amazon cloudfront') {
                const isDesktop = get(this.request, 'headers.cloudfront-is-desktop-viewer', 'true');
                return isDesktop !== 'true';
            }

        } else {
            return window.innerWidth < 768;
        }
    
        if (!userAgent) return false;
    
        const mobileRegex = /android|bb\d+|meego|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i;
    
        if (mobileRegex.test(userAgent)) {
            isMobile = true;
        }
    
        return isMobile;
    }
    
    getDevice() {
        return this.isMobile() ? DEVICE.MOBILE : DEVICE.DESKTOP;
    }

    getOS() {
        let userAgent = window.navigator.userAgent,
            platform = window.navigator.platform,
            macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
            windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
            iosPlatforms = ['iPhone', 'iPad', 'iPod'],
            os = null;

        if (macosPlatforms.indexOf(platform) !== -1) {
            os = 'macOS';
        } else if (iosPlatforms.indexOf(platform) !== -1) {
            os = 'iOS';
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
            os = 'windows';
        } else if (/Android/.test(userAgent)) {
            os = 'android';
        } else if (!os && /Linux/.test(platform)) {
            os = 'linux';
        } else {
            os = '“unknown“';
        }
        return os;
    }

	getResolution(image_type?: string) {

		if (this.platform.isServer()) {
			return 'xhdpi';
		}

		if (!this.isMobile() && image_type !== 'product') {
			return 'web';
		}

		const devicePixelRatio = window.devicePixelRatio;

		if (this._inRange(devicePixelRatio, 0, 2)) {
			return 'xhdpi';
		}

		if (this._inRange(devicePixelRatio, 2, 3)) {
			return 'xxhdpi';
		}

		if (this._inRange(devicePixelRatio, 3, 4)) {
			return 'xxxhdpi';
		}

		return 'xxhdpi';
	}

	private _inRange(x, min, max) {
		return x > min && x <= max;
	}
}
